/****************************************************
 * Module Name:  MoveToBoxModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button } from "@mui/material";
import Select from "react-select";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import MoveUpIcon from '@mui/icons-material/MoveUp';
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";

function MoveToBoxModal({
  show,
  setShow,
  handleSave,
  stoneIds,
  boxIdoptions,
  loading
}) {
  const [remark, setRemark] = useState("");
  const [showError, setShowError] = useState(false);
  const [boxSelectData, setBoxSelectData] = useState(boxIdoptions);

  const saveHandler = () => {
    if (handleSave) {
      handleSave(boxSelectData.box.value, stoneIds);
    } else {
      setShowError(true);
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            Cannot Move the stones
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        enforceFocus={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Move To Box
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box style={{ width: "8%" }}>
              <Form.Label>Box ID</Form.Label>
            </Box>
            <Box style={{ width: "92%" }}>
              <Select menuPlacement="auto"
                blurInputOnSelect={false}
                className="basic-single"
                classNamePrefix="select"
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                value={boxSelectData.box}
                isSearchable={true}
                name="Box ID"
                defaultValue={boxSelectData.box}
                menuPortalTarget={document.body}
                styles={Constants.Styles}
                options={boxSelectData.boxOptions}
                onChange={(selectedOption) => {
                  setBoxSelectData((prevState) => {
                    const updatedData = {
                      ...prevState,
                      box: selectedOption,
                    };
                    return updatedData;
                  });
                }}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Form.Label className="mt-2">Remark</Form.Label>
            <TextField
              id="outlined-multiline-static"
              label="Remark"
              multiline
              fullWidth
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            variant="contained"
            onClick={() => saveHandler()}
            type="Submit"
            color="success"
            sx={{ mr: 3 }}
            loading={loading}
            loadingPosition="start"
            startIcon={<MoveUpIcon size="large" />}
            disabled={boxSelectData.boxOptions.length === 0}
          >
            Move
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MoveToBoxModal;
